import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'ui-data-table-pagination',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  templateUrl: './data-table-pagination.component.html',
  styleUrl: './data-table-pagination.component.scss',
})
export class UiDataTablePaginationComponent {
  readonly currentPage  = input.required<number>();
  readonly totalPages   = input.required<number>();
  readonly visiblePages = input.required<readonly number[]>();
  readonly rangeStart   = input.required<number>();
  readonly rangeEnd     = input.required<number>();
  readonly total        = input.required<number>();

  readonly pageSelect = output<number>();

  protected readonly isFirst = computed(() => this.currentPage() === 0);
  protected readonly isLast  = computed(() => this.currentPage() >= this.totalPages() - 1);

  protected goToPage(page: number): void {
    if (page < 0 || page >= this.totalPages()) return;
    this.pageSelect.emit(page);
  }

  protected prev(): void { this.goToPage(this.currentPage() - 1); }
  protected next(): void { this.goToPage(this.currentPage() + 1); }
  protected first(): void { this.goToPage(0); }
  protected last(): void  { this.goToPage(this.totalPages() - 1); }
}
